import React, { useEffect } from 'react';
import { buildLogoutUrl } from '../utils/oidc';

export default function Logout() {
  useEffect(() => {
    try { window.localStorage.removeItem('currentUser'); } catch {}
    try { window.sessionStorage.removeItem('pkce_verifier'); } catch {}
    const domain = (typeof window !== 'undefined' && window.__COGNITO_DOMAIN__) || process.env.REACT_APP_COGNITO_DOMAIN || '';
    const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID || '';
    const logoutRedirectUri = window.location.origin + '/';
    if (domain && clientId) {
      const url = buildLogoutUrl({ domain, clientId, logoutRedirectUri });
      window.location.assign(url);
    } else {
      window.location.assign(logoutRedirectUri);
    }
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      Signing you out…
    </div>
  );
}


